// extracted by mini-css-extract-plugin
export default {"heroContainer":"styles_heroContainer__H5Lt6"};